export interface AllowedGlobals extends Window {
  legacyMode?: boolean;
}

export const getWindowObject = (): Window | WindowProxy => {
  // This is used for logical operations with window inside legacy mode. Keep in mind that it should not be used for measurements, as it's a wrapper in legacy mode
  const win = window as AllowedGlobals;
  return win.legacyMode ? window.parent : window;
};
